jQuery(document).ready(function ($) {
    "use strict";

    function setBodyPadding() {
        if ($('.main-header').length) {
            $('body').css({
                paddingTop: $('.main-header').outerHeight()
            });
        }
    }

    // Run on load
    setBodyPadding();

    // Run again on browser resize
    $(window).on('resize', function () {
        setBodyPadding();
    });

    $('.mobile-menu__item.menu-item-has-children').on('click', function (e) {
        $(this).toggleClass('mobile-menu__item--active');
        $(this).siblings().removeClass('mobile-menu__item--active');
    });

    $('.region-selector').on('click', function (e) {
        $(this).toggleClass( 'region-selector--active')
        $('.region-selector__dropdown').toggleClass('region-selector__dropdown--active');
    });

});
